import { render, staticRenderFns } from "./RemoteDetails.vue?vue&type=template&id=cd174694&"
import script from "./RemoteDetails.vue?vue&type=script&lang=ts&"
export * from "./RemoteDetails.vue?vue&type=script&lang=ts&"
import style0 from "./RemoteDetails.vue?vue&type=style&index=0&id=cd174694&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports